import { Link } from "react-router-dom";
import { getCategories } from "@/lib/navData";

export default function SiteFooter() {
  const categories = getCategories().slice(0, 8);
  const year = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-br from-primary-900 to-primary-950 text-primary-100 mt-16">
      <div className="max-w-page mx-auto px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-10 h-10 rounded-lg bg-background-50 text-primary-700 flex items-center justify-center font-heading font-extrabold text-lg">
                51
              </span>
              <span className="font-heading font-extrabold text-lg text-background-50">51网址导航</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-200">
              权威实用的网址入口集合门户，通过分类索引与精选推荐，帮助用户快速定位并访问热门及特色网站。
            </p>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-background-50 mb-4 text-sm">网站导航</h3>
            <ul className="space-y-2.5 text-sm">
              <li><Link to="/" className="hover:text-background-50 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/about" className="hover:text-background-50 transition-colors cursor-pointer">关于我们</Link></li>
              <li><Link to="/contact" className="hover:text-background-50 transition-colors cursor-pointer">联系我们</Link></li>
              <li><Link to="/search" className="hover:text-background-50 transition-colors cursor-pointer">搜索网址</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-background-50 mb-4 text-sm">热门分类</h3>
            <ul className="space-y-2.5 text-sm">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${encodeURIComponent(cat.id)}`}
                    className="hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold text-background-50 mb-4 text-sm">服务承诺</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-accent-400 mt-0.5" />
                <span>精选优质站点，分类清晰易查</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-accent-400 mt-0.5" />
                <span>所有入口新窗口打开，访问更安心</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-check-line text-accent-400 mt-0.5" />
                <span>持续更新收录，保持资源新鲜</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primary-800/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-primary-300">
          <p>© {year} 51网址导航 · 权威实用网址快速访问门户</p>
          <p>本页网址信息为演示内容，访问第三方网站请遵守相关平台规则</p>
        </div>
      </div>
    </footer>
  );
}